/**
 * Created by Dev0 on 12.05.14.
 */
callpy_global.CActivity = function()
{
    this.module_name = "Activity ";
    this.module_log_rang = 100;

    var _this = this;

    this.default_level = 550;

    if (callpy_from_ls) this.activity = (localStorage.getItem("callpy_activity")?localStorage.getItem("callpy_activity"):this.default_level);
    else this.activity = this.default_level;

    this.mouseTimer = null;
    this.scrollTimer = null;

    this.automessageTimer = null; //хранит таймеры автоприветствий (по времени)
    this.lastAutoMessage = null; //ссылка на последнее выведенное автоприветствие для избегания повторов при shuffle
    this.lastHoldMessage = null; // --//-- для удерживающих
    this.holdingTimer = null; //хранит таймеры удерживающих сообщений

    this.init = function ()
    {

        if (window.addEventListener) {
            window.addEventListener("mousemove", _this.handle_mouse, true);
            window.addEventListener("click", _this.handle_click, true);
            window.addEventListener("scroll", _this.handle_scroll, true);
        } else {
            window.attachEvent("onmousemove", _this.handle_mouse);
            window.attachEvent("onclick", _this.handle_click);
            window.attachEvent("onscroll", _this.handle_scroll);
        };

        if (!localStorage.getItem("callpy_activity_timer")){
            localStorage.setItem("callpy_activity_timer", new Date().getTime()+9500);
        }

        setTimeout(_this.reduce_activity, 10000);
        _this.automessage_init();

        _this.holding_init();

        //возможно, необходимо запустить таймер для автоприветствия. Это возможно в случае, когда при уже запущенном таймере клиент совершил переход по странице и функция, естественно, не выполнилась
        /*
        if (!localStorage.getItem("callpy_am")){

            //Если число секунд 0, автоприветствие выключено администратором
            if (parseInt(m_callpy.client_data.site_info["autogreet"])>0) {

                //также проверим, есть ли вообще консультант (эта функция может вызваться, когда консультант уходит, тогда передается 0)
                if (m_callpy.client_data.peer_key){

                    clearTimeout(_this.automessageTimer);
                    _this.automessageTimer = setTimeout(_this.automessage, parseInt(m_callpy.client_data.site_info["seconds"]*1000));

                }

            }

        }
        */

    };

    this.automessage_init = function()
    {
        //TODO: обработка новых автоприветствий по таймеру
        //установка таймеров для тех автоприветствий, для которых это актуально
        var greets = localStorage.getItem("callpy_greets"), uriDecoded;
        if (greets) greets = JSON.parse(greets);
        else localStorage.setItem("callpy_greets_timer", new Date().getTime());
        _this.automessageTimer = {};
        if (m_callpy.client_data.site_info.blocked!=0 || m_callpy.isMobile())return;
        for (var i=0; i<m_callpy.client_data.site_info.greets.length; i++){
            if (m_callpy.client_data.site_info.greets[i].term==1 && m_callpy.client_data.site_info.greets[i].status!=0 && (greets && greets[m_callpy.client_data.site_info.greets[i].id] != 1 || !greets)){ //term == 1 - автоприветствия по таймеру
                if (m_callpy.client_data.site_info.greets[i].urls.length > 0){
                    //если заданы страницы, на которых должны отображаться автоприветствия
                    var urls = m_callpy.client_data.site_info.greets[i].urls.split('|');
                    var exists = false;
                    for (var j=0; j<urls.length; j++){
                        //urls[j] == location.pathname - только для варианта "/", т.е. главной страницы сайта
                        try{
                            uriDecoded = decodeURIComponent(urls[j]);
                        }catch (e){
                            continue;
                        }
                        if ((urls[j].length>1 && decodeURIComponent(location.pathname).indexOf(uriDecoded)>=0) || (urls[j] == decodeURIComponent(location.pathname)) || urls[j].length == 0){
                            exists = true;
                            break;
                        }
                    }
                    if (!exists) continue;
                }
                var timeSpent = localStorage.getItem("callpy_enterTime");
                if (!timeSpent){
                    timeSpent = new Date().getTime();
                    localStorage.setItem("callpy_enterTime", timeSpent);
                }
                timeSpent = new Date().getTime() - timeSpent;
                //TODO: костыль имени Дениса. Предусматривает то, как он ожидал, что будет работать
                if (m_callpy.client_data.site_info.greets[i].urls.length>0) timeSpent = 0;

                _this.automessageTimer[m_callpy.client_data.site_info.greets[i].id] = setTimeout(function() {_this.automessage(arguments[0]);}, Math.max(0, m_callpy.client_data.site_info.greets[i].seconds*1000 - timeSpent), m_callpy.client_data.site_info.greets[i].id);
            }
        }
    }

    this.automessage_pageCheck = function()
    {
        var greets = localStorage.getItem("callpy_greets");
        if (greets) greets = JSON.parse(greets);
        else localStorage.setItem("callpy_greets_timer", new Date().getTime());
        for (var i=0; i<m_callpy.client_data.site_info.greets.length; i++){
            if (m_callpy.client_data.site_info.greets[i].term==0 && m_callpy.client_data.site_info.greets[i].status!=0 && (greets && greets[m_callpy.client_data.site_info.greets[i].id] != 1 || !greets)){ //term == 1 - автоприветствия по таймеру

                if (m_callpy.m_storage.pageViews == m_callpy.client_data.site_info.greets[i].pages){
                    _this.automessage(m_callpy.client_data.site_info.greets[i].id);
                }

            }
        }
    }

    this.holding_init = function()
    {
        if (m_callpy.client_data.site_info.blocked!=0 || m_callpy.isMobile())return;
        if (localStorage.getItem("callpy_hm")){
            var holds = localStorage.getItem("callpy_holds");
            if (holds) holds = JSON.parse(holds);
            _this.holdingTimer = {};
            for (var i=0; i<m_callpy.client_data.site_info.holds.length; i++){
                if (m_callpy.client_data.site_info.holds[i].status!=0 && (holds && holds[m_callpy.client_data.site_info.holds[i].id]!=1 || !holds)){
                    var timeSpent = localStorage.getItem("callpy_hm");
                    timeSpent = new Date().getTime() - timeSpent;
                    _this.holdingTimer[m_callpy.client_data.site_info.holds[i].id] = setTimeout(function() {_this.holdingmessage(arguments[0])}, Math.max(0, m_callpy.client_data.site_info.holds[i].seconds*1000 - timeSpent), m_callpy.client_data.site_info.holds[i].id);
                }
            }
        }
    }

    this.get_level = function(val)
    {
        return Math.floor(val/100);
    }

    this.add_activity = function(val, nosend)
    {
        var newlvl = Math.min(1099, Math.max(_this.default_level, _this.activity) + val);
        if (Math.abs(_this.get_level(newlvl) - _this.get_level(_this.activity))>=1 && !nosend){
            //посылаем менеджеру сообщение об изменении уровня активности клиента (если менеджер вообще есть)
            /*
            if (m_callpy.client_data.peer_key)
            m_callpy.m_bridge.to_peer(
                m_callpy.m_message.create_message("update_activity", {0: m_callpy.client_data.key, 1: _this.get_level(newlvl), 2: m_callpy.client_data.site_id}));
            else m_callpy.m_bridge.to_php(
                m_callpy.m_message.create_message("update_activity", {0: m_callpy.client_data.key, 1: _this.get_level(newlvl), 2: m_callpy.client_data.site_id}));
            */
        }
        _this.activity = newlvl;
        localStorage.setItem("callpy_activity", _this.activity);
    }

    this.decrease_activity = function(val)
    {
        var newlvl = Math.max(0, _this.activity - val);
        if (Math.abs(_this.get_level(newlvl) - _this.get_level(_this.activity))>=1){
            //посылаем менеджеру сообщение об изменении уровня активности клиента
            /*
            if (m_callpy.client_data.peer_key)
                m_callpy.m_bridge.to_peer(
                    m_callpy.m_message.create_message("update_activity", {0: m_callpy.client_data.key, 1: _this.get_level(newlvl), 2: m_callpy.client_data.site_id}));
            else m_callpy.m_bridge.to_php(
                m_callpy.m_message.create_message("update_activity", {0: m_callpy.client_data.key, 1: _this.get_level(newlvl), 2: m_callpy.client_data.site_id}));
            */
        }
        _this.activity = newlvl;
        localStorage.setItem("callpy_activity", _this.activity);
    }

    this.handle_mouse = function()
    {
        //_this.add_activity(0.1);
        clearTimeout(_this.mouseTimer);
        _this.mouseTimer = setTimeout(_this.handle_mouse_move, 500);
    }

    this.handle_mouse_move = function()
    {
        _this.add_activity(5);
    }

    this.handle_click = function()
    {
        _this.add_activity(20);
    }

    this.handle_scroll = function()
    {
        clearTimeout(_this.scrollTimer);
        _this.scrollTimer = setTimeout(_this.handle_scroll_move, 500);
        //_this.add_activity(20);
    }

    this.handle_scroll_move = function()
    {
        _this.add_activity(10);
    }

    this.reduce_activity = function()
    {
        if (new Date().getTime() > localStorage.getItem("callpy_activity_timer")){
            localStorage.setItem("callpy_activity_timer", new Date().getTime()+9500);
            _this.decrease_activity(20);
        }
        setTimeout(_this.reduce_activity, 10000);
    }

    this.automessage = function(id)
    {
        //Алгоритм показа автоприветствия и разворачивания чата
        //Верхний уровень: проверяем, было ли показано автоприветствие в рамках сессии и за последние несколько часов. Дальнейшие проверки - только если автоприветствие не показывалось
        var updateAutoCounter = false;

        if (!localStorage.getItem("callpy_am") && m_callpy.client_data.peer_key && m_callpy.client_data.site_info.blocked==0){
            //для случая одновременного запуска с нескольких вкладок: устанавливаем флаг обработки, блокирующий обработку на других вкладках
            localStorage.setItem("callpy_am", "1"); //начало обработки
            var greets = localStorage.getItem("callpy_greets");
            if (greets) greets = JSON.parse(greets);
            else {
                greets = {};
                localStorage.setItem("callpy_greets_timer", new Date().getTime());
                //UPDATED: необходимо обновить счётчик количества сессий с автоприветствиями
                updateAutoCounter = true;
            }

            if (!greets[id]){
                greets[id] = 1;
                localStorage.setItem("callpy_greets", JSON.stringify(greets));

                var greeting = null;

                for (var i=0; i<m_callpy.client_data.site_info["greets"].length; i++){
                    if (m_callpy.client_data.site_info["greets"][i].id == id){
                        greeting = m_callpy.client_data.site_info["greets"][i];
                        break;
                    }
                }

                if (greeting){
                    if (greeting.shuffle!=1)var msg = m_callpy.urlHighlight(greeting.text);
                    else{
                        var msg = [_("С удовольствием окажу профессиональную помощь, обращайтесь."), _("Если возникнут вопросы – пишите или звоните в 1 клик."), _("Могу проконсультировать Вас по любому вопросу. Пишите или звоните прямо с сайта.")];
                        var rand;
                        do{
                            rand = Math.random();
                            rand = Math.floor(rand*msg.length);
                        }while(rand==_this.lastAutoMessage);
                        msg = msg[rand];
                        _this.lastAutoMessage = rand;
                        /*
                        if (rand<0.33) msg = msg[0];
                        else if (rand<0.66) msg = msg[1];
                        else msg = msg[2];
                        */
                        msg = m_callpy.urlHighlight(msg);
                    }
                    var messageData = {
                        "department_id": m_callpy.client_data.department_id,
                        "extData": [],
                        "managerId": m_callpy.client_data.peer_key,
                        "managerName": m_callpy.managers_list[m_callpy.client_data.peer_key].name,
                        "message" : m_callpy.m_user.replacePatterns(msg),
                        "receiver" : m_callpy.client_data.key,
                        "sender" : m_callpy.client_data.peer_key,
                        "status_read": 0,
                        "status_received": 0,
                        "status_sent": new Date().getTime() / 1000,
                        "time": new Date().getTime() / 1000,
                        "timestamp": new Date().getTime() / 1000,
                        "type": 6,
                        "received": 1,
                        read: 1
                    };

                    $jcallpy.callpy_message('add', {
                        text: m_callpy.m_user.replacePatterns(msg),
                        from: 1,
                        auto: true,
                        time: new Date().getTime(),
                        read: 0,
                        messageType: 6
                        //messageType: 6
                    });

                    //UPDATED: для GA
                    if (window.gtag){
                        window.gtag('event', 'autogreeting', {
                            'event_category': 'callpy',
                            'event_label': 'id'+(greeting.id?greeting.id:'_rand')
                        });
                    } else if (window.ga){
                        window.ga('send', 'event', 'callpy', 'autogreeting', 'id'+(greeting.id?greeting.id:'_rand'));
                    }

                    m_callpy.m_chat.history.push(messageData);

                    //менеджера необходимо уведомить, что у этого клиента сработало автоприветствие, чтобы он видел его в истории сообщений
                    m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("automessage", {
                        "message": msg,
                        "messageData": JSON.stringify(messageData),
                        "save": (m_callpy.client_data.saveSysMes ? 1 : 0),
                        "updateAutoCounter": updateAutoCounter ? 1 : 0,
                        "time": new Date().getTime()
                    }));
                }

            }

            localStorage.removeItem("callpy_am"); //конец обработки
        }

        /*
        if (!localStorage.getItem("callpy_am") && m_callpy.client_data.peer_key){

            //переменную меняем в любом случае: дальнейшие проверки могут не пройти только по причине того, что клиенту по статистике не нужно показывать автоприветствие
            localStorage.setItem("callpy_am", "1");
            //проверяем по статистике, есть ли смысл показывать автоприветствие этому клиенту и разворачивать чат

            var msg = m_callpy.urlHighlight(m_callpy.client_data.site_info["greeting"]);
            $jcallpy.callpy_chat('message', {
                text: msg,
                from: 1
            });

            m_callpy.m_chat.history.push({"message" : msg, "receiver" : m_callpy.client_data.key, "sender" : m_callpy.client_data.peer_key});

            //менеджера необходимо уведомить, что у этого клиента сработало автоприветствие, чтобы он видел его в истории сообщений
            m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("automessage", {0: msg, 1: new Date().getTime()}));

        }
        */

    }

    this.holdingmessage = function(id)
    {
        if (localStorage.getItem("callpy_hm")){
            var holds = localStorage.getItem("callpy_holds");
            if (holds) holds = JSON.parse(holds);
            else holds = {};
            if (!holds[id] && m_callpy.client_data.site_info.blocked==0){ //если данное удерживающее сообщение еще не показывалось в рамках сессии
                holds[id] = 1;
                localStorage.setItem("callpy_holds", JSON.stringify(holds));

                var holding = null;
                for (var i=0; i<m_callpy.client_data.site_info.holds.length; i++){
                    if (m_callpy.client_data.site_info.holds[i].id == id){
                        holding = m_callpy.client_data.site_info.holds[i];
                        break;
                    }
                }

                if (holding){

                    if (holding.shuffle!=1) var msg = m_callpy.urlHighlight(holding.text);
                    else{
                        var msg = [_("Пожалуйста, подождите. Сейчас операторы заняты, но скоро кто-нибудь освободится и ответит вам!"), _("Немного терпения, прошу Вас. Я сейчас освобожусь и пообщаемся."), _("Не покидайте сайт пожалуйста, я общаюсь… Минутку…")];
                        var rand;
                        do{
                            rand = Math.random();
                            rand = Math.floor(rand*msg.length);
                        }while(rand==_this.lastHoldMessage);
                        msg = msg[rand];
                        _this.lastHoldMessage = rand;
                        /*
                        if (rand<0.33) msg = msg[0];
                        else if (rand<0.66) msg = msg[1];
                        else msg = msg[2];
                        */
                        msg = m_callpy.urlHighlight(msg);
                    }

                    var messageData = {
                        "department_id": m_callpy.client_data.department_id,
                        "extData": [],
                        "managerId": m_callpy.client_data.peer_key,
                        "managerName": m_callpy.managers_list[m_callpy.client_data.peer_key].name,
                        "message" : m_callpy.m_user.replacePatterns(msg),
                        "receiver" : m_callpy.client_data.key,
                        "sender" : m_callpy.client_data.peer_key,
                        "status_read": 0,
                        "status_received": 0,
                        "status_sent": new Date().getTime() / 1000,
                        "time": new Date().getTime() / 1000,
                        "timestamp": new Date().getTime() / 1000,
                        "type": 6,
                        "received": 1,
                        read: 1
                    };

                    if (parseInt(holding.contact_form) == 1) {
                        $jcallpy.callpy_message('_addSys', {
                            type: 'fields',
                            text: m_callpy.m_user.replacePatterns(msg)
                        });
                        //UPDATED: для GA
                        if (window.gtag){
                            window.gtag('event', 'autoholding', {
                                'event_category': 'callpy',
                                'event_label': 'phone_request'
                            });
                        } else if (window.ga){
                            window.ga('send', 'event', 'callpy', 'autoholding', 'phone_request');
                        }
                    }
                    else {
                        if (holding.type == 0){
                            $jcallpy.callpy_message('add', {
                                text: m_callpy.m_user.replacePatterns(msg),
                                from: 1,
                                auto: true,
                                time: new Date().getTime(),
                                read: 0,
                                messageType: 6
                            });
                            //UPDATED: для GA
                            if (window.gtag){
                                window.gtag('event', 'autoholding', {
                                    'event_category': 'callpy',
                                    'event_label': 'id'+(holding.id?holding.id:'_rand')
                                });
                            } else if (window.ga){
                                window.ga('send', 'event', 'callpy', 'autoholding', 'id'+(holding.id?holding.id:'_rand'));
                            }
                        }else{
                            //UPDATED: тип удерживающего - передать сообщение клиента всем онлайн (не отвечает)
                            //найдём последнее сообщение клиента (его и передадим)
                            var lastMessageId = 0, managerId = 0;
                            for (var i=m_callpy.m_chat.history.length - 1; i >= 0; i--){
                                if (m_callpy.m_chat.history[i].recieved == 0){
                                    lastMessageId = m_callpy.m_chat.history[i]["_id"]["$id"];
                                    managerId = m_callpy.m_chat.history[i].receiver;
                                    break;
                                }
                            }
                            if (lastMessageId != 0){
                                //отправка специального запроса на сервер (сообщение уходит всем консультантам отдела онлайн, кроме того, кому было адресовано изначально)
                                m_callpy.m_bridge.to_fms(m_callpy.m_message.create_message("holdingmessage", {
                                    "messageId": lastMessageId,
                                    "managerId": managerId,
                                    "id": holding.id,
                                    "site": m_callpy.client_data.site
                                }));
                            }
                        }
                    }

                    if (holding.type == 0) {
                        if (m_callpy.client_data.saveSysMes == 1){
                            //отправка сообщения на сервер для сохранения системного сообщения в БД
                            $jcallpy.post(callpy_global.php_server + '/d/', {
                                action: "save_sys_messages",
                                site_id: m_callpy.client_data.site_id,
                                site_url: m_callpy.client_data.site,
                                site: m_callpy.client_data.site,
                                managerName: m_callpy.managers_list[m_callpy.client_data.peer_key].name,
                                key: m_callpy.client_data.key,
                                peer_key: m_callpy.client_data.peer_key,
                                channel: m_callpy.client_data.channel,
                                messages: JSON.stringify([{type: "hold", message: messageData["message"], seconds: 0}])
                            }, function(data) {
                                data = JSON.parse(data);
                                messageData['_id'] = data[0]["_id"];
                                messageData['time'] = data[0]["timestamp"];
                                messageData['timestamp'] = data[0]["timestamp"];
                                m_callpy.m_chat.history.push(messageData);
                            });
                        }else{
                            m_callpy.m_chat.history.push(messageData);
                        }
                    }

                }

            }
        }
    }

};